module.exports = __webpack_public_path__ + "img/notIncluded.ce276408.svg";